export default __webpack_public_path__ + "static/media/sv44_en_rudl_a2.cfc820c9.mp3";